export const wrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '25vh',
};

export const messageStyle = {
    fontSize: '18px',
    marginBottom: '20px',
    textAlign: 'center',
    color: '#333',
    fontWeight: 'bold',
};

export const captchaStyle = {
    display: 'flex',
    justifyContent: 'center',
};